import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ButtonType } from "antd/lib/button";

interface LinkButtonProps {
  to: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  title?: string;
  type?: ButtonType;
}

export const LinkButton = ({ to, children, icon, title, type }: LinkButtonProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Button type={type ?? "link"} onClick={() => navigate(to, { state: location.state })} icon={icon} title={title}>
      {children}
    </Button>
  );
};
